import { useContext } from "react";
import { DashboardContext } from "../DashboardDrawerProvider";

export const useDashboardDrawer = () => useContext(DashboardContext);